module.exports = __webpack_public_path__ + "static/logo-white-2c06d717119e891d3880dff66bf98d06.png";